<template>
  <div v-if="rank" class="rank-tag" :class="rankClass">
    {{ rank > 3 ? rank : '' }}
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  rank?: number
}>()

const rankClass = computed(() => {
  if (!props.rank) {
    return ''
  }
  if (props.rank === 1) {
    return 'rank1'
  }
  if (props.rank === 2) {
    return 'rank2'
  }
  if (props.rank === 3) {
    return 'rank3'
  }
  return 'rank-some'
})
</script>

<style scoped lang="scss">
.rank-tag {
  position: absolute;
  top: -8px;
  left: -8px;
  background: center top no-repeat;
  background-size: contain;
  width: 48px;
  height: 58px;
  text-align: center;
  line-height: 50px;
  font-weight: 600;
  font-size: 24px;
  color: #451D00;
  &.rank1 {
    background-image: url("@/assets/images/search-result/rank_1.svg");
  }
  &.rank2 {
    background-image: url("@/assets/images/search-result/rank_2.svg");
  }
  &.rank3 {
    background-image: url("@/assets/images/search-result/rank_3.svg");
  }
  &.rank-some {
    background-image: url("@/assets/images/search-result/rank_some.svg");
  }
}

@media screen and (max-width: 768px) {
  .rank-tag {
    width: 40px;
    height: 43.5px;
    line-height: 37.5px;
    top: -4px;
    left: -4px;
    font-size: 20px;
  }
}
</style>
